import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { isBaseBetslipGroupPick, isBetslipBetBuilderPick } from '../../../../../../core/utils';
import { IBetslip } from '../../../../../bet-generation/models';
import { IncorrectOptionsCountPreCheckError } from '../../../../errors/pre-check/incorrect-options-count-pre-check-error';
import { ErrorDetailsSpecifier } from '../../../../errors/pre-check/pre-check-error';
import { ComboBetValidationContext } from '../../../../models/models';
import { IComboBetBetslipValidator } from '../validators';

@Injectable()
export class ComboBetIncorrectOptionsCountValidator implements IComboBetBetslipValidator<IncorrectOptionsCountPreCheckError> {
    constructor(private config: BetslipConfig) {}

    validate(_: IBetslip, context: ComboBetValidationContext): IncorrectOptionsCountPreCheckError[] {
        const totalPicksCount = context.totalPicksCount;
        const validPicksCount = context.validPicksCount;

        //the validator shouldn't run if we only have one pick and this pick is a bet builder pick, because it will conflict with bet builder picks leg count validator
        if (context.totalPicksCount === 1) {
            if (context.typeContext.selectedPicks.every(isBaseBetslipGroupPick)) {
                return [];
            }
            if (context.typeContext.selectedPicks.every(isBetslipBetBuilderPick) && this.config.isSportcastAsComboEnabled) {
                return [];
            }
        }

        if (totalPicksCount < this.config.minComboBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.minComboBets, totalPicksCount, ErrorDetailsSpecifier.MinComboBetsCount)];
        }

        if (validPicksCount < this.config.minComboBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.minComboBets, validPicksCount, ErrorDetailsSpecifier.SelectMinComboBets)];
        }

        if (validPicksCount > this.config.maxComboBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.maxComboBets, validPicksCount, ErrorDetailsSpecifier.SelectMaxComboBets)];
        }

        return [];
    }
}
